<div class="upload-container">
  <!-- Card for File from Disk -->
  <mat-card class="upload-options-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title
        >{{ 'upload.options.file_from_disk' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>{{ 'upload.options.choose_file_description' | translate }}</p>
    </mat-card-content>
    <mat-card-footer class="upload-options-card-footer">
      <app-file-upload
        #fileUploadComponent
        [inputLabel]="
          isUploading
            ? ('upload.options.loading' | translate)
            : ('upload.options.choose_upload' | translate)
        "
        [disabled]="isUploading"
        [allowedFileTypes]="['application/zip', 'application/qsarchive']"
        [selectableFileTypes]="'.zip, .qsarchive'"
        (fileUploaded)="onFileUploaded($event)"
      ></app-file-upload>
    </mat-card-footer>
  </mat-card>

  <!-- Card for File from Drone -->
  <!--  <mat-card class="upload-options-card" appearance="outlined">-->
  <!--    <mat-card-header>-->
  <!--      <mat-card-title>{{-->
  <!--        'upload.options.file_from_drone' | translate-->
  <!--      }}</mat-card-title>-->
  <!--    </mat-card-header>-->
  <!--    <mat-card-content>-->
  <!--      @if (!isDroneConnected) {-->
  <!--        <p>{{ 'upload.options.connect_drone' | translate }}</p>-->
  <!--      } @else {-->
  <!--        <p>{{ 'upload.options.drone_connected' | translate }}</p>-->
  <!--      }-->
  <!--    </mat-card-content>-->
  <!--    <mat-card-footer class="upload-options-card-footer">-->
  <!--      <app-file-upload-->
  <!--        [inputLabel]="'upload.options.retrieve_upload' | translate"-->
  <!--        [disabled]="!isDroneConnected"-->
  <!--        (fileUploaded)="onFileUploaded($event)"-->
  <!--      >-->
  <!--      </app-file-upload>-->
  <!--    </mat-card-footer>-->
  <!--  </mat-card>-->
</div>

<div class="info-text-container">
  <p class="info-text">
    {{ 'upload.options.verification_info' | translate }}
    <br />
    {{ 'upload.options.processing_status' | translate }}
  </p>
</div>
